import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useTranslation } from '../hooks/useTranslation';
import { languages } from '../i18n';
import { ExpandMore } from '../mui-icons';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
  const { currentLanguage, changeLanguage, availableLanguages, getCurrentLanguageInfo } = useLanguage();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  
  const currentLangInfo = getCurrentLanguageInfo();

  // Função para obter código da bandeira
  const getFlagCode = (languageCode) => {
    return languages[languageCode]?.flag || 'br';
  };

  const handleLanguageChange = (languageCode) => {
    changeLanguage(languageCode);
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="language-switcher">
      <button 
        className="language-switcher-button"
        onClick={toggleDropdown}
        aria-label={t('languageSwitcher.ariaLabel')}
      >
        <span className={`fi fi-${getFlagCode(currentLanguage)} language-flag`}></span>
        <ExpandMore className={`dropdown-icon ${isOpen ? 'open' : ''}`} />
      </button>
      
      {isOpen && (
        <div className="language-dropdown">
          {availableLanguages.map((lang) => (
            <button
              key={lang.code}
              className={`language-option ${currentLanguage === lang.code ? 'active' : ''}`}
              onClick={() => handleLanguageChange(lang.code)}
            >
              <span className={`fi fi-${getFlagCode(lang.code)} language-flag`}></span>
              <span className="language-name">{lang.name}</span>
              {currentLanguage === lang.code && (
                <span className="checkmark">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
